import styles from "../HealthChat.module.css";

/* ─── Icons ─────────────────────────────────────────────────────────────── */
const ClockIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const PROGRAM_CONTENT = {
  pcos: {
    title: "PCOS Care Program",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFTdCxHYUU_ZqfiH7-oqQeeZnwByYiR5GGjw&s",
    weeks: "8 weeks",
    sessions: "24 sessions",
    intro:
      "A complete program to help you manage PCOS symptoms, balance hormones and improve your overall wellbeing.",
    who: "Women with PCOS or symptoms like irregular periods, acne, weight gain, hair fall and fatigue.",
    price: "₹1,999",
  },
  fertility: {
    title: "Fertility Boost Program",
    image:
      "https://images.unsplash.com/photo-1518152006812-edab29b069ac?auto=format&fit=crop&q=80&w=400",
    weeks: "12 weeks",
    sessions: "36 sessions",
    intro:
      "A holistic approach to optimizing your reproductive health and increasing your chances of conception.",
    who: "Couples and individuals looking to improve their fertility naturally or alongside medical treatment.",
    price: "₹2,999",
  },
  pregnancy: {
    title: "Healthy Pregnancy Program",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFTdCxHYUU_ZqfiH7-oqQeeZnwByYiR5GGjw&s",
    weeks: "40 weeks",
    sessions: "Ongoing",
    intro:
      "Expert guidance for every trimester to ensure a healthy journey for you and your baby.",
    who: "Expectant mothers seeking nutrition, yoga, and medical guidance during their pregnancy journey.",
    price: "₹4,999",
  },
};
const CheckBadge = ({ color = "#4CAF50" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

/* ─── Main Component ────────────────────────────────────────────────────── */
export default function ProgramDetailScreen({ programId, onSelect, onBack }) {
  const data = PROGRAM_CONTENT[programId] || PROGRAM_CONTENT.pcos;
  const benefits = [
    { label: "Personalized care plan", color: "#4db6ac" },
    { label: "Nutrition & exercise guidance", color: "#81c784" },
    { label: "Yoga & stress management", color: "#64b5f6" },
    { label: "Expert webinars", color: "#9575cd" },
    { label: "Community support", color: "#4db6ac" },
  ];

  return (
    <div className={styles.detailWrapper}>
      <div className={styles.heroSection}>
        <button className={styles.detailBackBtn} onClick={onBack}>
          {" "}
          ←{" "}
        </button>
        <img src={data.image} alt={data.title} className={styles.heroImg} />
      </div>

      <div className={styles.detailBody}>
        <div className={styles.detailHeader}>
          <h1 className={styles.detailTitle}>{data.title}</h1>
          <span className={styles.popularBadgeDetail}>Popular</span>
        </div>

        <div className={styles.statsRow}>
          <div className={styles.statItem}>
            <ClockIcon /> {data.weeks}
          </div>
          <div className={styles.statDivider}>|</div>
          <div className={styles.statItem}>
            <ClockIcon /> {data.sessions}
          </div>
          <div className={styles.statDivider}>|</div>
          <div className={styles.statItem}>
            <ClockIcon /> Self-paced
          </div>
        </div>

        <p className={styles.detailIntro}>{data.intro}</p>
        <hr className={styles.detailDivider} />

        <h2 className={styles.sectionHeading}>What you'll get</h2>
        <div className={styles.benefitsList}>
          {benefits.map((b, i) => (
            <div key={i} className={styles.benefitItem}>
              <div
                className={styles.benefitIcon}
                style={{ background: `${b.color}15` }}
              >
                <CheckBadge color={b.color} />
              </div>
              <span className={styles.benefitLabel}>{b.label}</span>
            </div>
          ))}
        </div>

        <h2 className={styles.sectionHeading}>Who is this for?</h2>
        <p className={styles.whoText}>{data.who}</p>
      </div>
<div className={styles.priceFooterWrapper}>
      <div className={styles.priceFooter}>
        <div className={styles.priceInfo}>
          <span className={styles.priceAmount}>{data.price}</span>
          <span className={styles.priceTax}>Inclusive of all taxes</span>
        </div>
        <button className={styles.enrollBtn} onClick={onSelect}>
          Enroll now
        </button>
      </div>
    </div>
    </div>
  );
}
